import { Component, Input, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProvinceDto } from '../../../../generated-model/models';
import { formatRecordedAt, resolveRecordedBy } from '../../../shared/commons/audit-display.util';

@Component({
  selector: 'app-province-modal',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './province-modal.html'
})
export class ProvinceModal implements OnInit {
  @Input() province: ProvinceDto | undefined;
  @Input() viewOnly = false;
  @Input() onSave?: (payload: any, isEditMode: boolean) => Promise<boolean>;

  form: FormGroup;
  isEditMode = false;
  submitted = false;
  isSubmitting = false;
  recordedByDisplay = '-';
  recordedAtDisplay = '-';

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.form = this.fb.group({
      id: [null],
      code: ['', [Validators.required, Validators.maxLength(2)]],
      title: ['', [Validators.required, Validators.maxLength(255)]],
      ordering: [0, [Validators.max(32767)]],
      state: [1]
    });
  }

  ngOnInit(): void {
    if (this.province) {
      this.isEditMode = true;
      this.form.patchValue(this.province);
      this.recordedByDisplay = resolveRecordedBy(this.province);
      this.recordedAtDisplay = formatRecordedAt(this.province);
    } else {
      this.form.reset({ ordering: 0, state: 1 });
      this.recordedByDisplay = '-';
      this.recordedAtDisplay = '-';
    }

    if (this.viewOnly) {
      this.form.disable();
    }
  }

  save(): void {
    if (this.viewOnly) {
      return;
    }
    this.submitted = true;
    if (this.form.invalid) return;
    void this.submitAndClose(this.form.value);
  }

  private async submitAndClose(payload: any): Promise<void> {
    if (!this.onSave) {
      this.activeModal.close(payload);
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    try {
      const isSuccess = await this.onSave(payload, this.isEditMode);
      if (isSuccess) {
        this.activeModal.close(payload);
      }
    } finally {
      this.isSubmitting = false;
    }
  }
}
